'use strict';

// file-dropzone/paste.js — вставка файлов из буфера обмена (делегированная).
// Клик по кнопке сразу читает буфер через navigator.clipboard.read():
// файлы подставляются во вход компонента, если их нет — «В буфере обмена нет файлов».
// Важно: Clipboard API доступен только в secure context (https/localhost) —
// на http-доменах браузер не даёт JS читать буфер, показываем подсказку про HTTPS.

let TEXT_TYPES = {
    'text/plain': 'txt',
    'text/html': 'html',
    'text/csv': 'csv',
    'application/json': 'json'
};

function isSupportedType(type) {
    return type && (type.indexOf('image/') === 0 || TEXT_TYPES[type]);
}

// entries: [{type, blob}] -> File[] с именами pasted-image-N / pasted-text-N
function buildFiles(entries) {
    return entries.map(function (entry, i) {
        let ext = TEXT_TYPES[entry.type] || entry.type.split('/')[1] || 'bin';
        let prefix = TEXT_TYPES[entry.type] ? 'pasted-text' : 'pasted-image';
        return new File([entry.blob], prefix + '-' + i + '.' + ext, { type: entry.type });
    });
}

function filesToInput(files, component) {
    // Любой file-инпут внутри компонента (см. drag.js).
    let fileInput = component.find('input[type=file]').first();
    if (!files.length || !fileInput.length) return;

    let dt = new DataTransfer();
    files.forEach(function (f) { dt.items.add(f); });
    fileInput[0].files = dt.files;
    // Загрузку на сервер подхватит делегированный обработчик change компонента (upload.js / image-upload.js).
    fileInput.trigger('change');
}

jQuery(document).on('click', '.btn-paste-file', function () {
    let component = jQuery(this).closest('.file-dropzone-component, .image-upload-component');

    if (!navigator.clipboard || !navigator.clipboard.read) {
        window.showToast('Вставка из буфера обмена работает только по HTTPS', 'error');
        return;
    }

    navigator.clipboard.read().then(function (items) {
        let entries = [];
        items.forEach(function (item) {
            item.types.forEach(function (type) {
                if (isSupportedType(type)) {
                    entries.push({ type: type, promise: item.getType(type) });
                }
            });
        });

        if (!entries.length) {
            window.showToast('В буфере обмена нет файлов', 'error');
            return;
        }

        Promise.all(entries.map(function (e) { return e.promise; }))
            .then(function (blobs) {
                let files = buildFiles(blobs.map(function (blob, i) {
                    return { type: entries[i].type, blob: blob };
                }));

                // Для компонентов только с картинками (accept="image/*") оставляем лишь изображения.
                let accept = component.find('input[type=file]').first().attr('accept') || '';
                if (accept.indexOf('image/') !== -1) {
                    files = files.filter(function (f) { return f.type && f.type.indexOf('image/') === 0; });
                    if (!files.length) {
                        window.showToast('В буфере обмена нет изображений', 'error');
                        return;
                    }
                }

                filesToInput(files, component);
            }).catch(function () {});
    }).catch(function () {
        // Браузер не дал прочитать буфер (отказ в разрешении)
        window.showToast('Нет доступа к буферу обмена', 'error');
    });
});
